const REVIEWS = [
    {
        review_is:
            "Laufið er stórskemmtilegt verkfæri til að halda utan um stöðuna á aðgerðum Hópbíla og veitir gott aðhald í að gera sífellt betur í sjálfbærnimálum.",
        review_en:
            "The leaf is a great tool for keeping track of the status of Hópbíli's operations and provides good guidance in continually improving sustainability issues.",
        reviewerName: "Guðjón Árnason",
        reviewerTitle: "Umhverfisstjóri Hópbíla",
        reviewerTitle_is: "Umhverfisstjóri Hópbíla",
        reviewerTitle_en: "Environmental Manager of Hópbíla",
    },
    {
        review_is:
            "Við erum raunverulega búin að bíða í þó nokkuð mörg ár eftir hugbúnaði eins og Laufinu. Hugbúnaði til að halda utanum um sjálfbærnivegferð leikskólans sem byggir á grænum skrefum Umhverfisstofnunar og Grænfánans.",
        review_en:
            "We have actually been waiting for quite a few years for software like Laufin. Software to keep track of the preschool's sustainability journey that is based on the green steps of the Environmental Protection Agency and the Green Flag.",
        reviewerName: "Leikskólinn Norðurberg",
    },
    {
        review_is:
            "Margt smátt gerir eitt stórt. Laufið hjálpar okkur að halda faglega utan um sjálfbærnimálin okkar.",
        review_en:
            "Many small things make one big thing. The leaf helps us to professionally manage our sustainability issues.",
        reviewerName: "Ístex",
    },
];

export default REVIEWS;
